import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class BrivoInvalidFieldError extends CodedError {
  static get errorName() {
    return errorCodes.brivoInvalidFieldError.code;
  }

  constructor(message: string = errorCodes.brivoInvalidFieldError.message) {
    super(message);
    this.code = errorCodes.brivoInvalidFieldError.code;
    this.message = `${message} ${errorCodes.brivoInvalidFieldError.code}`;
    this.name = errorCodes.brivoInvalidFieldError.name;
  }
}
